module.exports = __webpack_public_path__ + "img/2.39304fb6.jpg";